export const no = {
  ns1: {
    "A newer version of the app opened a window. Reload to continue.":
      "En nyere versjon av appen åpnet et vindu. Last inn på nytt for å fortsette.",
    Reload: "Last inn på nytt",
    "Could not load local servers": "Kunne ikke laste inn lokale servere",
    "Toasts won't appear on small screens. Only the bell icon will show a notification in that case.":
      "Toast-varsler vises ikke på små skjermer. Da er det bare bjelleikonet som viser varselet.",
    "Toast notifications remain on the screen until dismissed. Critical notifications will appear in red.":
      "Toast-varsler blir værende på skjermen til de lukkes. Kritiske varsler vises i rødt.",
    "No internet connection": "Ingen internettforbindelse",
    pen_with_id: "Bur {{cageId}}",
    "Failed to move camera": "Kunne ikke flytte kameraet",
    Recording: "Opptak",
    "Event clip": "Hendelsesklipp",
    "Failed to save preset": "Kunne ikke lagre forhåndsinnstilling",
    "Failed to delete preset": "Kunne ikke slette forhåndsinnstilling",
    "Save camera preset": "Lagre kameraforhåndsinnstilling",
    "These coordinates will be saved with the preset.":
      "Disse koordinatene lagres med forhåndsinnstillingen.",
    "X offset": "X-forskyvning",
    "e.g. North feed point": "f.eks. nordlig fôringspunkt",
    "Delete preset": "Slett forhåndsinnstilling",
    "Preset name": "Navn på forhåndsinnstilling",
    Required: "Påkrevd",
    "Configure cage dimensions to view the digital twin":
      "Konfigurer burdimensjoner for å vise den digitale tvillingen",
    Expand: "Utvid",
    Collapse: "Skjul",
    "Expand digital twin": "Utvid digital tvilling",
    "Add to favourites": "Legg til i favoritter",
    "Remove from favourites": "Fjern fra favoritter",
    "Return to live": "Tilbake til sanntid",
    "Loading chart data...": "Laster diagramdata...",
    "Error loading data": "Feil ved lasting av data",
    server_not_found: "Ingen server funnet på {{ip}}:{{port}}.",
    "Feeding only": "Bare fôring",
    Map: "Kart",
    User: "Bruker",
    Users: "Brukere",
    Logout: "Logg ut",
    "No sites available": "Ingen nettsteder tilgjengelig",
    "Loading sites": "Laster nettsteder",
    "No site selected_other": "Ingen nettsteder valgt",
    "No site selected_one": "Ingen nettsted valgt",
    "Are you sure?": "Er du sikker?",
    "This action is irreversible.": "Denne handlingen er ugjenkallelig.",
    Delete: "Slett",
    Events: "Hendelser",
    "No data available": "Ingen data tilgjengelig",
    "No data for the selected time frame":
      "Ingen data for det valgte tidsintervallet",
    "New Scenario": "Ny Scenario",
    "New Strategy": "Ny Strategi",
    "Rename Strategy": "Gi nytt navn til Strategi",
    "Add Strategy": "Legg til Strategi",
    "Add Scenario": "Legg til Scenario",
    "Edit Scenario": "Rediger Scenario",
    "Delete Scenario": "Slett Scenario",
    "Delete Strategy": "Slett Strategi",
    "Rename Scenario": "Gi nytt navn til Scenario",
    New: "Ny",
    "New from": "Ny fra",
    "No events in the last 15 minutes": "Ingen hendelser de siste 15 minuttene",
    "Loading events": "Laster hendelser",
    Unit: "Enhet",
    Pens: "Bur",
    Pen: "Bur",
    Sites: "Nettsteder",
    All: "Alle",
    Units: "Enheter",
    Reasons: "Årsaker",
    "Manual Feeding": "Manuell Fôring",
    "Observe Feeding": "Observer Fôring",
    "Planned Feeding": "Planlagt Fôring",
    "Disabled Feeding": "Deaktivert Fôring",
    "Feed actions": "Fôringshandlinger",
    "No data available for current filter(s)":
      "Ingen data tilgjengelig for gjeldende filter",
    "Air speed": "Luftfartøy",
    Silo: "Sil",
    Visits: "Besøk",
    Visit: "Besøk",
    Automation: "Automatisering",
    Auto: "Auto",
    "Live Feeding": "Direkte Fôring",
    Live: "Direkte",
    Analytics: "Analyse",
    Data: "Data",
    "Activity change": "Aktivitetsendring",
    Alert: "Varsel",
    "Automation: Scenario change": "Automatisering: Scenarieendring",
    "Manual scenario change": "Manuell scenarieendring",
    "Feeding system change": "Fôringssystemendring",
    "Oxygen change": "Oksygenendring",
    "Salinity change": "Saltinnholdsendring",
    "Temperature change": "Temperaturendring",
    "Multiple sites": "Flere nettsteder",
    "All units": "Alle enheter",
    numberOfUnits: "{{numberOfUnits}} enheter",
    unitId: "Enhet {{unit}}",
    "Invalid username or password": "Ugyldig brukernavn eller passord",
    "Your password needs to be reset. You will have received a verification code in your email.":
      "Passordet ditt må tilbakestilles. Du har mottatt en verifiseringskode på e-posten din.",
    "If the account exists, you will have received a verification code in your email.":
      "Hvis kontoen eksisterer, har du mottatt en verifiseringskode på e-posten din.",
    "Invalid code or session": "Ugyldig kode eller økt",
    "Password successfully changed": "Passordet ble endret",
    "Invalid new password": "Ugyldig nytt passord",
    "Password has been successfully changed. Use to log in from now on.":
      "Passordet har blitt endret. Bruk det for å logge inn fra nå av.",
    "OTP client successfully set up. Now you can log in":
      "OTP-klienten ble vellykket satt opp. Nå kan du logge inn",
    "Could not set up the OTP client": "Kunne ikke sette opp OTP-klienten",
    "Feed units": "Fôringsenheter",
    Filter: "Filter",
    "No units are feeding at the moment": "Ingen enheter fôrer for øyeblikket",
    "No units available": "Ingen enheter tilgjengelig",
    "Remove filter": "Fjern filter",
    "Feeding mode": "Fôringsmodus",
    Strategy: "Strategi",
    Scenario: "Scenario",
    "Strategies not synced": "Strategier ikke synkronisert",
    Overview: "Oversikt",
    "Search site": "Søk nettsted",
    "No results": "Ingen resultater",
    "Select All": "Velg Alle",
    Loading: "Laster",
    "Alert Groups": "Varselgrupper",
    "No groups found": "Ingen grupper funnet",
    Cancel: "Avbryt",
    Save: "Lagre",
    "Discard changes?": "Forkast endringer?",
    "You'll lose all changes made to this scenario":
      "Du vil miste alle endringer gjort på dette scenariet",
    "More Than": "Mer enn",
    "Less Than": "Mindre enn",
    Calendar: "Kalender",
    Rotas: "Rotas",
    Comments: "Kommentarer",
    "Clear Rota": "Tøm Rota",
    "Add Rota": "Legg til Rota",
    Farmer: "Bondegårdseier",
    "Create Farmer": "Opprett Bondegårdseier",
    "Add rota": "Legg til rota",
    "rota will be overwritten_one": "{{count}} rota vil bli overskrevet",
    "rota will be overwritten_other": "{{count}} rotas vil bli overskrevet",
    Warning: "Advarsel",
    "Email already exists": "E-posten eksisterer allerede",
    "Error creating user": "Feil ved opprettelse av bruker",
    "Error creating rota": "Feil ved opprettelse av rota",
    Comment: "Kommentar",
    "To Comment": "Kommentere",
    "Add comment": "Legg til kommentar",
    Presets: "Forhåndsinnstillinger",
    Submit: "Send inn",
    "Error creating comment": "Feil ved opprettelse av kommentar",
    Now: "Nå",
    "All day": "Hele dagen",
    "No comments": "Ingen kommentarer",
    Goals: "Mål",
    Subgoal: "Delmål",
    Score: "Poengsum",
    "See Examples": "Se Eksempler",
    "Show Conditions": "Vis Betingelser",
    Disable: "Deaktiver",
    Enable: "Aktiver",

    "No goals found": "Ingen mål funnet",
    "No data": "Ingen data",
    "Save Changes": "Lagre Endringer",
    "Couldn't update configuration.": "Kunne ikke oppdatere konfigurasjonen.",
    "No configuration available for this goal.":
      "Ingen konfigurasjon tilgjengelig for dette målet.",
    "Configuration updated successfully.":
      "Konfigurasjonen ble oppdatert vellykket.",
    "No pens were updated. Changes apply only to active (non-fallowed) pens.":
      "Ingen merder ble oppdatert. Endringer gjelder kun aktive (ikke-brakklagte) merder.",
    Example: "Eksempel",
    Breakdown: "Nedbrytning",
    "No breakdown available": "Ingen nedbrytning tilgjengelig",
    "Sort by": "Sorter etter",
    "Date: Newest to Oldest": "Dato: Nyeste til Eldste",
    "Date: Oldest to Newest": "Dato: Eldste til Nyeste",
    "Score: Best to Worst": "Poengsum: Best til Verst",
    "Score: Worst to Best": "Poengsum: Verst til Best",
    Evidence: "Bevis",
    Filters: "Filtre",
    "Configurations updated successfully":
      "Konfigurasjoner oppdatert vellykket",
    "No evidence found for this date range":
      "Ingen bevis funnet for dette datointervallet",
    "Access Denied": "Tilgang nektet",
    "You don't have access to this page": "Du har ikke tilgang til denne siden",
    "Please contact your administrator":
      "Vennligst kontakt administratoren din",
    or: "eller",
    "Sign out": "Logg ut",
    Summary: "Oppsummering",
    "Shift Analysis": "Skiftsanalyse",
    "Days of note for": "Dager av merknad for {{name}}",
    "Pens for": "Bur for {{name}}",
    Analyse: "Analysere",
    "Highest Performing Sites": "Nettsteder med Høyest Ytelse",
    "Lowest Performing Sites": "Nettsteder med Lavest Ytelse",
    Goal: "Mål",
    "No sites with scores found": "Ingen nettsteder med poengsum funnet",
    "Camera Automation": "Kameraautomatisering",
    Camera: "Kamera",
    "Feed Automation": "Fôrautomatisering",
    Feed: "Fôr",
    Line: "Linje",
    "Feed Rate (Kg/min)": "Fôrhastighet (Kg/min)",
    "Visit (Kgs)": "Besøk (Kgs)",
    "No strategies found": "Ingen strategier funnet",
    "When pen": "Når bur",
    "is feeding, use preset": "fôrer, bruk forhåndsinnstilling",
    "Add Preset": "Legg til Forhåndsinnstilling",
    "Edit Preset": "Rediger Forhåndsinnstilling",
    Add: "Legg til",
    Edit: "Rediger",
    Configuration: "Konfigurasjon",
    admin_configuration: "Admin-konfigurasjon",
    notifications_center: "Varslingssenter",
    notifications_center_message:
      "Denne siden lar deg abonnere på og konfigurere varsler direkte til e-posten din, samt mer omfattende optimaliseringsrapporter",
    create_new: "Lag ny",
    notification_updated_successfully: "Varsling oppdatert.",
    When: "Når",
    "is feeding": "fôrer",
    "use preset": "bruk forhåndsinnstilling",
    "You will no longer see scores for":
      "Du vil ikke lenger se poengsum for {{name}} fra nå av",
    "Error deleting comment": "Feil ved sletting av kommentar",
    "Daily Average": "Daglig Gjennomsnitt",
    "No sites selected": "Ingen nettsteder valgt",
    environmental: "Miljø",
    predators: "Rovdyr",
    camera: "Kamera Hardware Problem",
    feed_system: "Fôrsystem Problem",
    net_cleaning: "Nettrensing",
    mortality: "Dødelighet",
    Language: "Språk",
    Alerts: "Varsler",
    "Remove Pin": "Fjern festing",
    "This pen": "Dette buret",
    "Alerts on this pen": "Varsler på dette buret",
    "Alerts on {{feedline}}": "Varsler på {{feedline}}",
    "Pinned to {{feedline}}": "Festet til {{feedline}}",
    "Will move pin from another cell": "Flytter festingen fra en annen celle",
    "{{name}} (current)": "{{name}} (gjeldende)",
    Pellets: "Pellets",
    Activity: "Aktivitet",
    Oxygen: "Oksygen",
    Graph: "Graf",
    "Feed Graph": "Fôrgraf",
    "Pressure Graph": "Trykkgraf",
    "Feed Amount": "Fôrmengde",
    "Feed Rate": "Fôrrate",
    "Set Feed Rate": "Sett fôrrate",
    "Enter feed rate": "Angi fôrrate",
    "Feed Status": "Fôrstatus",
    "Feed target": "Fôringsmål",
    "Appetite Factor": "Appetittfaktor",
    "Stopping Depth": "Stoppdybde",
    Shifts: "Skift",
    "Create User": "Opprett Bruker",
    Confirm: "Bekreft",
    "First name": "Fornavn",
    "Last name": "Etternavn",
    Email: "E-post",
    Emails: "E-poster",
    "Email Type": "E-posttype",
    Depth: "Dybde",
    Name: "Navn",
    Create: "Opprett",
    Rename: "Gi nytt navn",
    Dome: "Dome",
    Descent: "Nedstigning",
    Type: "Type",
    "Add Starting Depth": "Legg til Startdybde",
    "Add Stopping Depth": "Legg til Stoppdybde",
    "Add Depth": "Legg til Dybde",
    "depth must be bellow": "Dybde må være under {{minDepth}}m",
    "depth must be above": "Dybde må være over {{minDepth}}m",
    "Depth is already used": "Dybde er allerede brukt",
    "Continuously rotate camera": "Kontinuerlig roter kamera",
    "Tilt camera down before rotation": "Vipp kameraet ned før rotasjon",
    "Rotate for": "Roter i",
    "Pause Between": "Pause mellom sveip",
    "Alternate Direction Each Sweep": "Veksle retning for hvert sveip",
    "Sweeps Each Direction": "Sveip i hver retning",
    "Point camera down": "Peke kamera ned",
    "Go to starting position (end of visit)":
      "Gå til start posisjon (slutten av besøket)",
    "What should the camera do?": "Hva skal kameraet gjøre?",
    "What depth?": "Hva dybde?",
    "When does the camera go up?": "Når går kameraet opp?",
    "When does the camera go down?": "Når går kameraet ned?",
    "Create Pause": "Opprett Pause",
    "Edit Pause": "Rediger Pause",
    "Seconds to Pause": "Sekunder til Pause",
    Columns: "Kolonner",
    Total: "Totalt",
    "Best Score": "Beste Poengsum",
    "Worst Score": "Verste Poengsum",
    Weeks: "Uker",
    "Least Pellets": "Minst Pellets",
    "Most Pellets": "Mest Pellets",
    "Pellets & Alerts": "Pellets & Varsler",
    "Pellets/Alert": "Pellets/Varsel",
    "Severity [%]": "Alvorlighetsgrad [%]",
    "Feed Amount [kg]": "Fôrmengde [kg]",
    "Feed Rate [kg/min]": "Fôrhastighet [kg/min]",
    "Feed Time [min]": "Fôrtid [min]",
    "Feed Dose [kg]": "Fôrdose [kg]",
    "Feed Amount/Pellet [kg/Pellet]": "Fôrmengde/Pellet [kg/Pellet]",
    "Alert Responsiveness": "Varsel Responsivitet",
    "Total Responsiveness [%]": "Total Responsivitet [%]",
    "Camera Responsiveness [%]": "Kamera Responsivitet [%]",
    "Feeding Responsiveness [%]": "Fôrings Responsivitet [%]",
    "Alert Activity [%]": "Varsel Aktivitet [%]",
    "Feeding Activity [%]": "Fôrings Aktivitet [%]",
    "Camera Depth": "Kamera Dybde",
    "Camera Action": "Kamerahandling",
    "Hold & watch": "Hold og overvåk",
    "Rotate to scan": "Roter for å skanne",
    "Camera Movement": "Kamerabevegelse",
    "Depth increasing": "Dybde øker",
    "Depth decreasing": "Dybde synker",
    Temperature: "Temperatur",
    "Pipe Pressure": "Rørtrykk",
    "Feeding Depth": "Fôrings Dybde",
    "Alert Depth": "Varsel Dybde",
    Sensors: "Sensorer",
    "Selected sensor is unavailable, showing another source":
      "Valgt sensor er utilgjengelig, viser en annen kilde",
    Automatic: "Automatisk",
    "camera's own": "kameraets egen",
    "No sensor of this type on the pen": "Ingen sensor av denne typen i merden",
    "Failed to save the camera's sensor": "Kunne ikke lagre kameraets sensor",
    "Sensors this camera reads": "Sensorer dette kameraet leser",
    "Sensors at camera depth": "Sensorer på kameraets dybde",
    "Save to choose sensors for the new pen":
      "Lagre for å velge sensorer for den nye merden",
    "Could not load this camera's sensors":
      "Kunne ikke laste sensorene til dette kameraet",
    Custom: "Egendefinert",
    "None on this pen": "Ingen i denne merden",
    Winch: "Vinsj",
    "Advanced settings": "Avanserte innstillinger",
    "Assign this camera to a pen to choose its sensors":
      "Knytt kameraet til en merd for å velge sensorene",
    "Edit Camera": "Rediger Kamera",
    "Add Camera": "Legg til Kamera",
    "Edit Winch": "Rediger Vinsj",
    "Add Winch": "Legg til Vinsj",
    "Winch Type": "Vinsjtype",
    "Edit Pen": "Rediger Bur",
    "Add Pen": "Legg til Bur",
    "Edit Sensor": "Rediger Sensor",
    "Add Sensor": "Legg til Sensor",
    Connected: "Tilkoblet",
    "Not connected": "Ikke tilkoblet",
    "Oxygen 0-6m": "Oksygen 0-6m",
    "Feeding Oxygen 0-6m": "Fôrings Oksygen 0-6m",
    "Temperature 0-6m": "Temperatur 0-6m",
    "Most Feed Amount/Pellet": "Mest Fôrmengde/Pellet",
    "Least Feed Amount/Pellet": "Minst Fôrmengde/Pellet",
    Biomass: "Biomasse",
    "Average Growth [kg]": "Gjennomsnittlig Vekst [kg]",
    "Average Weight [kg]": "Gjennomsnittlig Vekt [kg]",
    "Highest Weight [kg]": "Høyeste Vekt [kg]",
    "Lowest Weight [kg]": "Laveste Vekt [kg]",
    "Highest Growth [kg]": "Høyeste Vekst [kg]",
    "Lowest Growth [kg]": "Laveste Vekst [kg]",
    en: "English",
    es: "Español",
    no: "Norsk",
    "Admin Configuration": "Admin Konfigurasjon",
    Notifications: "Varslinger",
    Groups: "Grupper",
    "Show scheduler visit groups": "Vis besøksgrupper fra planleggeren",
    "Group {{number}} · {{start}}–{{end}} · {{visits}} visits · {{percent}}%":
      "Gruppe {{number}} · {{start}}–{{end}} · {{visits}} besøk · {{percent}}%",
    "Start feeding": "Start fôring",
    "Pause feeding": "Pause fôring",
    "Stop feeding": "Stopp fôring",
    "More options": "Flere valg",
    "Reset to original schedule": "Tilbakestill til opprinnelig plan",
    "Stop feed for the whole day": "Stopp fôring for hele dagen",
    Catchup: "Ta igjen",
    "Restores all planned feed after now":
      "Gjenoppretter all planlagt fôring etter nå",
    "Not currently allowed in micro feeding":
      "Ikke tillatt ved mikrofôring for øyeblikket",
    "Main Menu": "Hovedmeny",
    Overfeeding: "Overfôring",
    Underfeeding: "Underfôring",
    Standardization: "Standardisering",
    "Are there any pellet spikes?": "Er det noen pellettopper?",
    "Which units stand out?": "Hvilke enheter skiller seg ut?",
    "Pellets/Feed Amount": "Pellets/Fôrmengde",
    "Feed Amount/Pellet": "Fôrmengde/Pellet",
    "Overfeeding Feed Deviation": "Overfôring av fôravvik",
    "Feeding Response": "Fôrrespons",
    "Underfeeding Feed Deviation": "Underfôring av fôravvik",
    "Limit Grazing": "Begrens beiting",
    Satiation: "Metthet",
    "Camera Movements": "Kamerabevegelser",
    "Feed Profile Smoothness": "Fôrprofilens jevnhet",
    "Which days of feeding should I pay attention to?":
      "Hvilke fôringsdager bør jeg være oppmerksom på?",
    "Pellet Spike": "Pelletspike",
    "Is the feed rate adapting to the fish enough?":
      "Endres fôringshastigheten nok etter fiskens atferd?",
    "Where could we potentially push the feeding further?":
      "Hvor kan vi potensielt øke fôringen videre?",
    "Are the cameras being optimally positioned?":
      "Er kameraene optimalt plassert?",
    "What trends are consistent on my site?":
      "Hvilke trender er konsistente på lokaliteten min?",
    Grazing: "Beiting",
    Severity: "Alvorlighetsgrad",
    "What would you like to track?": "Hva vil du spore?",
    "User sites": "Brukerområder",
    "User permission groups": "Brukertillatelsesgrupper",
    "Something has gone wrong": "Noe har gått galt",
    Error: "Feil",
    Refresh: "Oppdater",
    Retry: "Prøv igjen",
    "This page could not be loaded": "Denne siden kunne ikke lastes",
    "Could not connect to the server": "Kunne ikke koble til serveren",
    "The app could not start": "Appen kunne ikke starte",
    "Try again. If it keeps happening, contact support.":
      "Prøv igjen. Hvis det fortsetter å skje, kontakt kundestøtte.",
    "Check your network connection and try again.":
      "Sjekk nettverkstilkoblingen og prøv igjen.",
    "You cannot change your own permissions":
      "Du kan ikke endre dine egne tillatelser",
    "Page Not Found": "Siden ble ikke funnet",
    "The page you are looking for doesn't exist":
      "Siden du leter etter eksisterer ikke",
    "Please check the URL or try navigating to another page":
      "Vennligst sjekk URL-en eller prøv å navigere til en annen side",
    "Go to Home": "Gå til Hjem",
    "Video Page Layout": "Video Sideoppsett",
    "Camera Layout": "Kameraoppsett",
    "Video Aspect Ratio": "Videoformat",
    Original: "Original",
    Stretch: "Strekk",
    Crop: "Beskjær",
    cage_id: "Bur Id",
    "Screen Configuration": "Skjermkonfigurasjon",
    "Save Current Configuration": "Lagre Gjeldende",
    "Reset to Default Configuration": "Tilbakestill til Standard",
    "Save Current Configuration Description":
      "Lagre gjeldende skjermkonfigurasjon for å huske hvilke skjermer som er synlige",
    "Default Graph Time Range": "Standard tidsintervall for graf",
    "Camera in Camera": "Kamera i kamera",
    "Camera size": "Kamerastørrelse",
    Small: "Liten",
    Medium: "Middels",
    Large: "Stor",
    "Pellet Detection": "Pelletdeteksjon",
    "Render Detections": "Vis deteksjoner",
    None: "Ingen",
    "Reset to Default Configuration Description":
      "Tilbakestill alle skjermer til å vise som standard",
    "Saving...": "Lagrer...",
    "Resetting...": "Tilbakestiller...",
    "Saved!": "Lagret!",
    use_acv4_mapping: "Flytt kameraer i ACv4 for å flytte i Observe",
    use_observe_endpoints: "Bruk Observe API-endepunkter (standard: SEAV)",
    "Welcome to Observe Tide!": "Velkommen til Observe Tide!",
    "Use the ": "Bruk ",
    "to select a page": "for å velge en side",
    "within a span of": "innen et tidsrom på",
    "Download Config": "Last ned konfigurasjon",
    "Upload Config": "Last opp konfigurasjon",
    feeding: "Fôring",
    general_info: "Generell Info",
    equipment_challenges: "Utstyrsproblemer",
    treatment: "Behandling",
    harvest: "Høsting",
    "Visit created": "Besøk opprettet",
    "Visit deleted": "Besøk slettet",
    "Feeding Settings": "Fôringsinnstillinger",
    Copilot: "Copilot",
    Manual: "Manuell",
    "Add server": "Legg til server",
    "Copy from site": "Kopier fra nettsted",
    "Data Router": "Dataruter",
    "Equipment Integration": "Utstyrsintegrasjon",
    "for more than": "i mer enn",
    "integration for": "Integrasjon for",
    "Local Configuration": "Lokal konfigurasjon",
    "Local Servers": "Lokale servere",
    "Notification Settings": "Varslingsinnstillinger",
    "Video Page Settings": "Videosideinnstillinger",
    General: "Generelt",
    "Default Info Rows": "Standard informasjonsrader",
    "Reset to defaults": "Tilbakestill til standard",
    "Saving replaces the info rows on every camera on the video page.":
      "Lagring erstatter informasjonsradene på alle kameraer på videosiden.",
    "Row 1": "Rad 1",
    "Row 2": "Rad 2",
    "Row 3": "Rad 3",
    "Time range": "Tidsintervall",
    "Settings saved successfully": "Innstillingene ble lagret",
    "Failed to save settings": "Kunne ikke lagre innstillingene",
    "Failed to load settings": "Kunne ikke laste inn innstillingene",
    "Site has no cages": "Nettstedet har ingen bur",
    "This site is not running the latest Marlin. Upgrade for the latest features.":
      "Dette nettstedet kjører ikke den nyeste Marlin. Oppgrader for de nyeste funksjonene.",
    camera_service: "Kameratjeneste",
    Connection: "Tilkobling",
    Copy: "Kopier",
    Defaults: "Standardverdier",
    feed_service: "Fôringstjeneste",
    Feeding: "Fôring",
    for: "for",
    Integrations: "Integrasjoner",
    Local: "Lokal",
    Notification_updated_successfully: "Varsling oppdatert",
    other: "Annet",
    Port: "Port",
    seconds: "sekunder",
    Servers: "Servere",
    Settings: "Innstillinger",
    Site: "Nettsted",
    Machine: "Maskin",
    Support: "Støtte",
    Troubleshooting: "Feilsøking",
    Video: "Video",
    Address: "Adresse",
    Cloud: "Sky",
    Dashboard: "Dashbord",
    Default: "Standard",
    Group: "Gruppe",
    "Integration provider": "Integrasjonsleverandør",
    License: "Lisens",
    Q: "S",
    Version: "Versjon",
    "and this occured": "og dette skjedde",
    once: "én gang",
    "times within a span of": "ganger innen et tidsrom på",
    "View active schedule": "Vis aktiv timeplan",
    "More info": "Mer info",
    Advanced: "Avansert",
    Fixed: "Fast",
    "Growth Model": "Vekstmodell",
    "What would you like to call this default?":
      "Hva vil du kalle denne planen?",
    "What time does your feeding day start?": "Når starter fôringsdagen din?",
    "What time does your feeding day end?": "Når slutter fôringsdagen din?",
    "How is the daily target determined?": "Hvordan bestemmes dagsmålet?",
    "How much are you aiming to feed today?":
      "Hvor mye har du planlagt å fôre i dag?",
    "What is your average base feed rate across this day?":
      "Hva er den gjennomsnittlige grunnleggende fôringshastigheten din gjennom dagen?",
    "Allowed overshoot": "Tillatt overskridelse",
    "Spread feed evenly across the day": "Fordel fôret jevnt utover dagen",
    "Follow recent feed rate": "Følg nyeste fôringshastighet",
    "How are the fish fed?": "Hvordan fôres fisken?",
    "Meal Feeding": "Måltidsfôring",
    "Micro / Cyclic Feeding": "Mikro-/syklisk fôring",
    "Meal Feeding: pellets go out in a few discrete meals across the day. Micro / Cyclic Feeding: feed is spread into many small, repeating deliveries.":
      "Måltidsfôring: pellets deles ut i noen få adskilte måltider gjennom dagen. Mikro-/syklisk fôring: fôret fordeles på mange små, gjentakende leveringer.",
    "Minimum time between visits": "Minste tid mellom besøk",
    "Optional. The shortest gap allowed between two feeding visits on the same cage. Leave blank for no minimum.":
      "Valgfritt. Det korteste tillatte mellomrommet mellom to fôringsbesøk i samme merd. La stå tomt for ingen minimumsgrense.",
    "Total Groups": "Totalt antall grupper",
    "Total Visits": "Totalt antall besøk",
    "Average Visit": "Gjennomsnittlig besøk",
    "Group Start Time": "Gruppens starttid",
    "Group End Time": "Gruppens sluttid",
    "Group Feed %": "Gruppens fôr%",
    "Number of Visits": "Antall besøk",
    "Give this feeding plan a name so you can find it later. Something like 'summer plan' or 'small fish' works well.":
      "Gi denne fôringsplanen et navn slik at du finner den igjen senere. Noe som 'sommerplan' eller 'liten fisk' fungerer fint.",
    "Earliest time of day the fish are allowed to be fed.":
      "Tidligste tidspunkt på dagen fisken kan fôres.",
    "Latest time of day feeding is allowed. After this, no more pellets go out.":
      "Seneste tidspunkt på dagen det er lov å fôre. Etter dette går det ikke ut flere pellets.",
    "Fixed: you type in the total kilograms of feed per day. Growth Model: the system works out the amount from how much the fish weigh and how fast they grow.":
      "Fast: du skriver inn totalt antall kilo fôr per dag. Vekstmodell: systemet regner ut mengden ut fra hvor mye fisken veier og hvor raskt den vokser.",
    "Total kilograms of feed to hand out today across every cage on the feedline.":
      "Totalt antall kilo fôr som skal deles ut i dag på tvers av alle merder på fôrlinja.",
    "How fast pellets can be fed, in {{unit}}. This is usually the feeding machine's normal speed.":
      "Hvor raskt pellets kan fôres, i {{unit}}. Dette er som regel fôringsmaskinens normale hastighet.",
    "Defaults use kg/min or g/s. Change unit in Feed Settings to use {{unit}}.":
      "Standardverdier bruker kg/min eller g/s. Endre enhet i Fôringsinnstillinger for å bruke {{unit}}.",
    "No default": "Ingen standard",
    "How much extra above the daily target the system may feed if the fish are still hungry. 15% means it can go up to 15% over the target.":
      "Hvor mye ekstra over dagsmålet systemet kan fôre hvis fisken fortsatt er sulten. 15% betyr at det kan gå opp til 15% over målet.",
    "ON: visits are packed tightly across the day so feeding time is used efficiently. OFF: visits stay inside the group time windows you set.":
      "PÅ: besøkene pakkes tett gjennom dagen slik at fôringstiden brukes effektivt. AV: besøkene holder seg innenfor tidsvinduene du har satt per gruppe.",
    "Only matters when you add a new cage to the feedline. ON: the new cage keeps the feed rate the other cages were already using. OFF: the new cage starts from the base feed rate above.":
      "Har bare betydning når du legger til en ny merd på fôrlinja. PÅ: den nye merden beholder fôringshastigheten de andre merdene allerede brukte. AV: den nye merden starter fra grunnhastigheten over.",
    "How many feeding sessions per day you have set up below.":
      "Hvor mange fôringsøkter per dag du har satt opp nedenfor.",
    "Total number of pellet deliveries across the whole day.":
      "Totalt antall pelletsleveringer gjennom hele dagen.",
    "Average kilograms of feed handed out per visit. Just the daily target split evenly across all visits.":
      "Gjennomsnittlig antall kilo fôr som deles ut per besøk. Bare dagsmålet delt jevnt på alle besøk.",
    "Time this group of feeding visits begins.":
      "Tidspunktet denne gruppen med fôringsbesøk starter.",
    "Time this group of feeding visits ends.":
      "Tidspunktet denne gruppen med fôringsbesøk slutter.",
    "Share of the daily target that belongs to this group. All groups together should add up to 100%.":
      "Andel av dagsmålet som tilhører denne gruppen. Alle gruppene til sammen skal utgjøre 100%.",
    "How many separate feed deliveries happen inside this group. More visits = smaller portions each time.":
      "Hvor mange separate fôrleveringer som skjer i denne gruppen. Flere besøk = mindre porsjoner hver gang.",
    "End must be after start": "Slutt må være etter start",
    "Can't add a visit in the past": "Kan ikke legge til et besøk i fortiden",
    "Can't move a visit into the past": "Kan ikke flytte et besøk til fortiden",
    "Overlaps a visit on this feedline":
      "Overlapper et besøk på denne fôringslinjen",
    "Pen is at its feed target — no room":
      "Buret er på fôringsmålet sitt — ingen plass",
    "The added visit exceeds the feed amount remaining in this pen":
      "Det tillagte besøket overskrider fôrmengden som gjenstår i dette buret",
    "The visit exceeds the feed amount remaining in this pen":
      "Besøket overskrider fôrmengden som gjenstår i dette buret",
    "Can't add a cluster in the past":
      "Kan ikke legge til en klynge i fortiden",
    "Can't move a cluster into the past":
      "Kan ikke flytte en klynge til fortiden",
    "Overlaps another cluster in this pen":
      "Overlapper en annen klynge i dette buret",
    "A cluster must sit inside one feeding group's window":
      "En klynge må ligge innenfor vinduet til én fôringsgruppe",
    "Outside the schedule's feeding window": "Utenfor planens fôringsvindu",
    Start: "Start",
    End: "Slutt",
    "Feed · feed rate {{rate}} kg/min × duration · max {{headroom}} kg of {{target}} kg target":
      "Fôr · fôringsrate {{rate}} kg/min × varighet · maks {{headroom}} kg av {{target}} kg mål",
    "Group window {{window}}": "Gruppevindu {{window}}",
    "No feeding group covers this window":
      "Ingen fôringsgruppe dekker dette vinduet",
    "{{count}} visits · {{kg}} kg_one": "{{count}} besøk · {{kg}} kg",
    "{{count}} visits · {{kg}} kg_other": "{{count}} besøk · {{kg}} kg",
    "no visits": "ingen besøk",
    "{{minutes}} min · ~{{cadence}} min apart":
      "{{minutes}} min · ~{{cadence}} min mellomrom",
    "{{minutes}} min": "{{minutes}} min",
    "~{{cadence}} min apart": "~{{cadence}} min mellomrom",
    "{{kg}} kg/visit": "{{kg}} kg/besøk",
    optional: "valgfritt",
    "e.g. catch-up feed, vet requested…":
      "f.eks. ekstra fôring, bestilt av veterinær…",
    "e.g. bad weather, pen treated…": "f.eks. dårlig vær, merden behandlet…",
    "Add visit": "Legg til besøk",
    "Add cluster": "Legg til klynge",
    "Schedule change rejected": "Planendringen ble avvist",
    Idle: "Inaktiv",
    "{{count}} pen_one": "{{count}} bur",
    "{{count}} pen_other": "{{count}} bur",
    "Delete this visit?": "Slette dette besøket?",
    "Delete visit": "Slett besøk",
    "Delete this cluster?": "Slette denne klyngen?",
    "Delete cluster": "Slett klynge",
    "Feed rate (kg/min)": "Fôringsrate (kg/min)",
    "{{kg}} kg planned": "{{kg}} kg planlagt",
    "Daily feed target (kg)": "Daglig fôringsmål (kg)",
    "Feeding ends": "Fôring slutter",
    "Target met": "Mål nådd",
    Close: "Lukk",
    "Click to change the daily feed target":
      "Klikk for å endre det daglige fôringsmålet",
    "Click to change the feed rate": "Klikk for å endre fôringsraten",
    "No feedings": "Ingen fôringer",
    Blower: "Blåser",
    "{{hours}}h {{minutes}}m": "{{hours}} t {{minutes}} min",
    "{{minutes}}m": "{{minutes}} min",
    "Feeding ends {{label}}": "Fôring slutter {{label}}",
    "Estimate if fed at appetite factor 1":
      "Estimat hvis det fôres med appetittfaktor 1",
    "Drag to defer the remaining feed to later":
      "Dra for å utsette gjenværende fôr til senere",
    "Drag to move · click to edit or delete":
      "Dra for å flytte · klikk for å redigere eller slette",
    "Drag to change the start time": "Dra for å endre starttidspunktet",
    "Drag to extend the remaining feed": "Dra for å forlenge gjenværende fôr",
    "Drag to extend the cluster": "Dra for å forlenge klyngen",
    "Drag to change the end time": "Dra for å endre sluttidspunktet",
    "Feed target met": "Fôringsmål nådd",
    "{{delta}} kg over target": "{{delta}} kg over målet",
    "{{delta}} kg to reach target": "{{delta}} kg for å nå målet",
    "target {{target}} kg": "mål {{target}} kg",
    Fish: "Fisk",
    System: "System",
    "Feed line": "Fôringslinje",
    "Relative Activity": "Relativ aktivitet",
    "Trend (Short)": "Trend (kort)",
    "Trend (Med)": "Trend (middels)",
    "Trend (Long)": "Trend (lang)",
    "# of Fish": "Antall fisk",
    "Relative Visibility": "Relativ sikt",
    Schooling: "Stimatferd",
    Distance: "Avstand",
    Speed: "Hastighet",
    "Feed (kg/min)": "Fôr (kg/min)",
    "Feed (g/s)": "Fôr (g/s)",
    "Feed (p/fish/min)": "Fôr (p/fisk/min)",
    "Feed (kg/t/min)": "Fôr (kg/t/min)",
    "Total Feed": "Totalt fôr",
    "Feed Score": "Fôringsscore",
    "Appetite Adjustment": "Appetittjustering",
    "Visit Feed (g)": "Fôr per besøk (g)",
    "Visit Number": "Besøksnummer",
    "Remaining Visits": "Gjenstående besøk",
    Salinity: "Salinitet",
    Saturation: "Metning",
    Pressure: "Trykk",
    "Average Weight": "Gjennomsnittsvekt",
    "Condition Factor": "Kondisjonsfaktor",
    "Coefficient of Variation": "Variasjonskoeffisient",
    "Specific Growth Rate": "Spesifikk vekstrate",
    "Relative Growth Index": "Relativ vekstindeks",
    "Growth Rate": "Vekstrate",
    "Total Lice": "Totalt antall lus",
    "Air Speed (m/s)": "Lufthastighet (m/s)",
    "Water Flow (m³/h)": "Vannstrøm (m³/h)",
    "Water Flow [m³/h]": "Vannstrøm [m³/h]",
    "Silo Level (%)": "Silonivå (%)",
    "Line status": "Linjestatus",
    Compare: "Sammenlign",
    "Total feed amount compared to yesterday":
      "Total fôrmengde sammenlignet med i går",
    Today: "I dag",
    Yesterday: "I går",
    "Hide from chart": "Skjul fra diagram",
    "Show in chart": "Vis i diagram",
    Feedline: "Fôringslinje",
    Schedules: "Planer",
    Active: "Aktiv",
    OK: "OK",
    "is required": "er påkrevd",
    "must be a number": "må være et tall",
    "must be at least": "må være minst",
    "must be at most": "må være maksimalt",
    "must be greater than": "må være større enn",
    "must be a whole number": "må være et heltall",
    "can have at most": "kan ha maksimalt",
    "decimal place": "desimal",
    "decimal places": "desimaler",
    Discard: "Forkast",
    Finish: "Fullfør",
    Overshoot: "Overskyting",
    Scheduler: "Planlegger",
    sec: "sek",
    min: "min",
    "Feed Now": "Fôr nå",
    "Add Back": "Legg tilbake",
    "Apply to All": "Bruk på alle",
    "Catch Up": "Ta igjen",
    "Start Time": "Starttid",
    "End Time": "Sluttid",
    "Planned Feed": "Planlagt fôring",
    "Target Feed": "Målfôring",
    "Percentage Total": "Prosent totalt",
    "New Schedule": "Ny plan",
    "Wait Block": "Venteblokk",
    "Advanced Settings": "Avanserte innstillinger",
    "Schedule name": "Plannavn",
    "Time Between Visits": "Tid mellom besøk",
    "Minimum time to wait between consecutive feeding visits to this pen when go to next is triggered. Visits are spaced so the feeder pauses at least this long before feeding.":
      "Minste ventetid mellom påfølgende fôringsbesøk til dette buret når «gå til neste» utløses. Besøkene fordeles slik at fôringsautomaten venter minst så lenge før den fôrer.",
    "Save schedule?": "Lagre plan?",
    "Are you sure you want to save the changes to this schedule?":
      "Er du sikker på at du vil lagre endringene i denne planen?",
    "Planned feed deviates from expected":
      "Planlagt fôring avviker fra forventet",
    "Review feed deviation warnings before saving":
      "Gå gjennom advarsler om fôringsavvik før du lagrer",
    "Cannot save schedule": "Kan ikke lagre planen",
    "Resolve the following errors before saving":
      "Løs følgende feil før du lagrer",
    "Save Anyway": "Lagre likevel",
    "Decrease Feed Rate or Feed Time": "Reduser fôringsrate eller fôringstid",
    "Increase Feed Rate or Feed Time": "Øk fôringsrate eller fôringstid",
    "This will clear all visits for this feed line":
      "Dette fjerner alle besøk for denne fôringslinjen",
    "No Feedline Found": "Fant ingen fôringslinje",
    "No Feedlines Found": "Fant ingen fôringslinjer",
    "No Pens Found": "Fant ingen bur",
    "No Schedules Found": "Fant ingen planer",
    "All unsaved changes will be lost.": "Alle ulagrede endringer går tapt.",
    "You have unsaved changes to this group. Closing will discard them.":
      "Du har ulagrede endringer i denne gruppen. Hvis du lukker, forkastes de.",
    "There is currently no selected active schedule for this feedline":
      "Det er ingen valgt aktiv plan for denne fôringslinjen",
    "Group percentages must add up to 100%":
      "Gruppeprosentene må summere til 100 %",
    "Every group must have at least one visit":
      "Hver gruppe må ha minst ett besøk",
    "At least one pen must stay in the plan":
      "Minst ett bur må bli værende i planen",
    "Start time is required": "Starttid er påkrevd",
    "End time is required": "Sluttid er påkrevd",
    "Visits must be greater than 0": "Besøk må være større enn 0",
    "Percentage must be at least 0": "Prosent må være minst 0",
    "Cannot exceed {{max}}%": "Kan ikke overstige {{max}} %",
    "Planned feed is {{percent}}% above expected":
      "Planlagt fôring er {{percent}} % over forventet",
    "Planned feed is {{percent}}% below expected":
      "Planlagt fôring er {{percent}} % under forventet",
    "Cage {{cageId}}": "Bur {{cageId}}",
    "Fix: {{fix}}": "Løsning: {{fix}}",
    'This will permanently delete the schedule "{{name}}". This action cannot be undone.':
      'Dette sletter planen "{{name}}" permanent. Denne handlingen kan ikke angres.',
    "{{count}} seconds_one": "{{count}} sekund",
    "{{count}} seconds_other": "{{count}} sekunder",
    Continue: "Fortsett",
    "Saved — with changes": "Lagret — med endringer",
    "Your change was saved. The following adjustments were made:":
      "Endringen din ble lagret. Følgende justeringer ble gjort:",
    "Fed so far: {{fedKg}} kg": "Fôret så langt: {{fedKg}} kg",
    "Planned: {{plannedKg}} kg": "Planlagt: {{plannedKg}} kg",
    "Target: {{targetKg}} kg": "Mål: {{targetKg}} kg",
    "Overshoot: {{overshootPct}} %": "Overskyting: {{overshootPct}} %",
    "Planned Feed - {{plannedKg}} kg": "Planlagt fôring - {{plannedKg}} kg",
    "Target Feed - {{targetKg}} kg": "Målfôring - {{targetKg}} kg",
    "Overshoot - {{overshootPct}} %": "Overskyting - {{overshootPct}} %",
    Cluster: "Klynge",
    "op.itemDesc": "{{type}} {{start}}-{{end}} ({{pen}})",
    "op.dayWindow.outsideDay":
      "{{item}} faller utenfor fôringsvinduet ({{dayStart}}-{{dayEnd}}). Flytt eller forkort det så det passer innenfor de timene.",
    "op.dayWindow.outsideGroup":
      "{{item}} faller utenfor sitt fôringsgruppevindu ({{groupStart}}-{{groupEnd}}). Flytt eller forkort det så det passer innenfor de timene.",
    "op.adjacent.snappedLine":
      "{{item}} ble justert til å starte {{legalStart}} slik at det ligger rett etter {{other}} på den delte fôringslinjen.",
    "op.adjacent.snappedPen":
      "{{item}} ble justert til å starte {{legalStart}} slik at det ligger rett etter {{other}} i samme bur.",
    "op.contention.overlapLine":
      "{{item}} overlapper {{other}} på den delte fôringslinjen — bare ett besøk kan kjøre om gangen.",
    "op.contention.overlapPen":
      "{{item}} overlapper {{other}} i samme bur — klynger kan ikke overlappe.",
    "op.contention.blowerGap":
      "{{item}} starter bare {{gap}} s etter {{other}} på den delte fôringslinjen. Ulike bur trenger minst {{requiredGap}} s mellom besøk for at linjen skal klareres — spre dem lenger fra hverandre.",
    "op.inverted":
      "{{item}} slutter samtidig med eller før det starter. Gi det en sluttid etter starttiden.",
    "op.waitBlock":
      "{{item}} starter under en venteblokk ({{blockStart}}-{{blockEnd}}). Venteblokken forkortes til å slutte når besøket begynner.",
    "op.groupWindow.noGroup":
      "{{item}} faller ikke innenfor noen fôringsgruppe for dette buret. Flytt det inn i en fôringsgruppes timer for å lagre.",
    "op.groupWindow.trimmed":
      "{{item}} ble forkortet til {{start}}-{{end}} ({{minutes}} min) for å passe inn i sin fôringsgruppe ({{groupStart}}-{{groupEnd}}).",
    "op.dailyTarget.exceeded":
      "{{pen}} er satt til å fôre {{plannedKg}} kg. Daglig mål er {{targetKg}} kg — fjern eller forkort et besøk for å redusere det.",
    "op.dailyTarget.noTarget":
      "{{pen}} har ingen fôringsmål for i dag, så det operative målet kan ikke lagres.",
    "op.dailyTarget.notInPlan":
      "Merd {{cageId}} er ikke med i planen for fôringslinje {{feedLineId}}",
    "op.schedule.notOnFeedline":
      "Planen som er lastet for {{feedLineId}}, er ikke den aktive planen for den fôringslinjen. Oppdater siden og gjør endringen på nytt.",
    "fineTune.diff.feedRate": "Fôrrate",
    "fineTune.diff.target": "Mål",
    "fineTune.diff.order": "Rekkefølge",
    "fineTune.diff.groupVisits": "Besøk i gruppe {{n}}",
    "fineTune.diff.removed": "Fjernet fra planen",
    "fineTune.diff.added": "Lagt tilbake i planen",
    "fineTune.title": "Finjuster plan",
    "fineTune.subtitle": "Fra standard {{name}}",
    "fineTune.matchesDefault": "Samsvarer med standard",
    "fineTune.changes_one": "{{count}} endring",
    "fineTune.changes_other": "{{count}} endringer",
    "fineTune.resetToDefault": "Tilbakestill til standard",
    "fineTune.target": "Mål",
    "fineTune.blowerGap": "Blåseropphold",
    "fineTune.seconds": "{{seconds}} s",
    "fineTune.feedRateUnit": "Fôrrate {{unit}}",
    "fineTune.targetKgSource": "Mål kg · {{source}}",
    "fineTune.visitsPlanned": "Besøk · Planlagt",
    "fineTune.removeFromPlan": "Fjern fra planen",
    "fineTune.addBackToPlan": "Legg tilbake i planen",
    "fineTune.reset": "Tilbakestill",
    "fineTune.done": "Ferdig",
    "fineTune.window": "Vindu",
    "fineTune.share": "Andel",
    "fineTune.removedFromPlan": "Fjernet fra planen",
    "fineTune.removedBar":
      "Fjernet fra planen · de andre burene planlegges uten det",
    "fineTune.growthSwitched":
      "Målet følger ikke lenger vekstmodellen. Hvert bur beholder sitt eget mål.",
    "fineTune.footerNote":
      "Ingenting er aktivt før du lagrer. Lagring erstatter dagens plan for {{line}}.",
    "fineTune.groupShort": "G{{n}}",
    "fineTune.groupName": "Gruppe {{n}}",
    "fineTune.moveEarlier": "Fôr {{pen}} tidligere",
    "fineTune.moveLater": "Fôr {{pen}} senere",
    "fineTune.lowerRate": "Senk raten",
    "fineTune.raiseRate": "Øk raten",
    "fineTune.fewerVisits": "Færre besøk",
    "fineTune.moreVisits": "Flere besøk",
    "fineTune.discardTitle": "Forkaste endringene?",
    "fineTune.discardDescription":
      "Finjusteringen er ikke lagret. Lukker du nå, går den tapt.",
    "fineTune.discardConfirm": "Forkast",
    "fineTune.defaultNotActive":
      "{{line}} kjører ikke lenger {{default}}. Lukk dette og velg standarden på nytt.",
    "siteOverview.apply": "Bruk",
    "siteOverview.fineTune": "Finjuster",
    "siteOverview.removeDefaultTitle": "Fjerne standarden fra {{line}}?",
    "siteOverview.removeDefaultDescription": "Planen stopper.",
    "siteOverview.removeDefaultConfirm": "Fjern",
    "siteOverview.replaceTitle": "Finjusteringen på {{line}} blir erstattet",
    "siteOverview.replaceConfirm": "Fortsett",
    "siteOverview.drawerEditing":
      "Planleggeren har ulagrede endringer. Lagre eller avbryt dem før du bruker eller finjusterer en standard.",
    "siteOverview.removeDefaultFailed":
      "Kunne ikke fjerne standarden fra {{line}}: {{message}}",
    "Live Pellets": "Live-pellets",
    "Co-pilot": "Kopilot",
    "Feed Amount (Kg)": "Fôrmengde (kg)",
    "Temperature (°C)": "Temperatur (°C)",
    "Visits Total": "Totalt besøk",
    "Pipe Pressure Bar": "Rørtrykk (bar)",
    "Oxygen (mg/L)": "Oksygen (mg/L)",
    "Feed Mode": "Fôringsmodus",
    "Line Status": "Linjestatus",
    "Visit (Kg)": "Besøk (kg)",
    "Next Scenario": "Neste scenario",
    AF: "AF",
    Table: "Tabell",
    Timeline: "Tidslinje",
    "How much in Kg has been fed this visit":
      "Hvor mange kg som er fôret på dette besøket",
    "How much in Kg has been fed today": "Hvor mange kg som er fôret i dag",
    "Lets you visualise the graph(s) selected in the column selector, for current feed rate and/or pressure for each pen":
      "Lar deg visualisere graf(ene) som er valgt i kolonnevelgeren, for gjeldende fôringsrate og/eller trykk for hver merd",
    "CO-PILOT": "CO-PILOT",
    "This feature lets you run predefined strategies to achieve better results with less manual effort.":
      "Denne funksjonen lar deg kjøre forhåndsdefinerte strategier for å oppnå bedre resultater med mindre manuelt arbeid.",
    "Use this table to change strategy, scenario, or feed mode while in copilot mode. Toggle off co-pilot in this table to bring the pen back to manual feeding mode.":
      "Bruk denne tabellen til å endre strategi, scenario eller fôringsmodus mens du er i co-pilot-modus. Slå av co-pilot i denne tabellen for å sette merden tilbake til manuell fôring.",
    "FEED PAGE": "FÔRSIDE",
    "This page helps you manage line statuses, feed rates, and the Co-pilot function.":
      "Denne siden hjelper deg med å administrere linjestatuser, fôringsrater og Co-pilot-funksjonen.",
    "This Screen": "Denne skjermen",
    "Entire Setup": "Hele oppsettet",
    "No templates saved yet": "Ingen maler lagret ennå",
    "Save Current Layout": "Lagre gjeldende oppsett",
    "Save Current Screen…": "Lagre gjeldende skjerm…",
    "Save Layout Template": "Lagre oppsettmal",
    "Save Screen Layout Template": "Lagre skjermoppsettmal",
    "Template Name": "Malnavn",
    "Enter template name...": "Skriv inn malnavn...",
    "Please enter a template name": "Skriv inn et malnavn",
    "Template name must be 50 characters or less":
      "Malnavnet kan ikke være lengre enn 50 tegn",
    "Save Template": "Lagre mal",
    "Delete Template": "Slett mal",
    "Delete Screen Template": "Slett skjermmal",
    'Are you sure you want to delete the template "{{templateName}}"? This action cannot be undone.':
      'Er du sikker på at du vil slette malen "{{templateName}}"? Denne handlingen kan ikke angres.',
    "Select Template": "Velg mal",
    "Loading...": "Laster...",
    "Deleting...": "Sletter...",
    Surface: "Overflate",
    Barge: "Flåte",
    Other: "Annet",
    Subsurface: "Under vann",
    "Subsurface - top (looking up)": "Under vann - topp (ser opp)",
    "Subsurface - bottom (looking down)": "Under vann - bunn (ser ned)",
    "Camera Model": "Kameramodell",
    "Connect Exit Good to a scenario before saving its conditions":
      "Koble Exit Good til et scenario før du lagrer betingelsene",
    "Connect Exit Bad to a scenario before saving its conditions":
      "Koble Exit Bad til et scenario før du lagrer betingelsene",
    "Add an exit condition before adding a pause":
      "Legg til en utgangsbetingelse før du legger til en pause",
    "4-digit PIN": "4-sifret PIN",
    "Back to saved accounts": "Tilbake til lagrede kontoer",
    "Change PIN": "Endre PIN",
    "Choose a PIN": "Velg en PIN",
    "Choose an account to continue.": "Velg en konto for å fortsette.",
    "Confirm your PIN": "Bekreft PIN-koden din",
    "Couldn't set up your PIN.": "Kunne ikke konfigurere PIN-koden din.",
    "Enter the same 4 digits again.": "Skriv inn de samme 4 sifrene igjen.",
    "Enter your PIN": "Skriv inn PIN-koden din",
    "Enter your password": "Skriv inn passordet ditt",
    "Failed to cancel sign-in": "Kunne ikke avbryte innloggingen",
    "Failed to forget this email": "Kunne ikke glemme denne e-postadressen",
    "Failed to reset password": "Kunne ikke tilbakestille passordet",
    "Failed to set new password": "Kunne ikke angi nytt passord",
    "Failed to set up authenticator":
      "Kunne ikke konfigurere autentiseringsappen",
    "Failed to start password reset":
      "Kunne ikke starte tilbakestilling av passordet",
    "Failed to verify code": "Kunne ikke bekrefte koden",
    "Forget this email": "Glem denne e-postadressen",
    "Forgot password?": "Glemt passordet?",
    "Incorrect PIN.": "Feil PIN-kode.",
    "Attempts left:": "Gjenværende forsøk:",
    "Log in": "Logg inn",
    "Log in with a different email": "Logg inn med en annen e-postadresse",
    "Log in with password": "Logg inn med passord",
    "Not now": "Ikke nå",
    "Offline login isn't available on this device yet. Log in online first.":
      "Frakoblet innlogging er ikke tilgjengelig på denne enheten ennå. Logg inn på nett først.",
    PIN: "PIN",
    Password: "Passord",
    "Password login needs an internet connection.":
      "Innlogging med passord krever internettilkobling.",
    "Pick 4 digits you will remember. Used on this device only.":
      "Velg 4 sifre du husker. Brukes kun på denne enheten.",
    "Set up PIN": "Konfigurer PIN",
    "Set up quick login?": "Konfigurere hurtiginnlogging?",
    "Sign-in failed": "Innloggingen mislyktes",
    "Signing in as": "Logger inn som",
    "Skip for now": "Hopp over for nå",
    "Skip typing your password next time — sign in with a 4-digit PIN on this device.":
      "Slipp å skrive passordet neste gang – logg inn med en 4-sifret PIN på denne enheten.",
    "Those PINs did not match. Start again.":
      "PIN-kodene stemte ikke overens. Start på nytt.",
    "Too many incorrect attempts. Log in with your password when you're back online.":
      "For mange feil forsøk. Logg inn med passordet ditt når du er tilkoblet igjen.",
    "Too many incorrect attempts. Log in with your password.":
      "For mange feil forsøk. Logg inn med passordet ditt.",
    "Welcome back": "Velkommen tilbake",
    "Your offline session has expired. Log in with your password when you're back online.":
      "Den frakoblede økten din er utløpt. Logg inn med passordet ditt når du er tilkoblet igjen.",
    "Your password has been reset. Please log in.":
      "Passordet ditt er tilbakestilt. Logg inn.",
    "Your password must be reset before you can log in.":
      "Passordet ditt må tilbakestilles før du kan logge inn.",
    "Your quick login has expired. Log in with your password to renew it.":
      "Hurtiginnloggingen din er utløpt. Logg inn med passordet ditt for å fornye den.",
  },
};
